import GlobalNav from "./GlobalNav"

window.onload = () => {
  new GlobalNav()
}
